import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Text = {
  Component,
  makeDefault,
  isValidData,
} as const;

export type { TextData, TextNodeData } from './types';
